import { InsuranceDocumentsResponse, InsuranceResponse } from "@/models/api/InsuranceResponse";
import { Insurance } from "@/models/www/Insurance";
import contentService from "@/services/content.service";
import insuranceService from "@/services/insurance.service";
import { ref } from "vue";

const useInsurance = () => {
    const insurances = ref<Insurance[]>();

    const getInsurances = (): Promise<Insurance[]> => {
        return new Promise((resolve, reject) => {
            const promises: Promise<unknown>[] = [insuranceService.getInsurances(), contentService.getInsuranceDocuments()];
            Promise.all(promises).then(([resources, documents]) => {
                insurances.value = (resources as InsuranceResponse[])
                    .map(r => new Insurance(r, (documents as InsuranceDocumentsResponse[])
                        .find(d => d.type === r.insuranceType)?.documents))
                resolve(insurances.value);
            }).catch((err) => reject(err))
        })
    }

    return { getInsurances, insurances }
}

export default useInsurance;